<template>
  <div class="iframe-modal">
    <div class="iframe-modal-content">
      <div class="top-row" style="padding: 10px">
        <div @click="closeModal" style="margin: 0 0 0 auto">
          <VIcon :icon="'cross'" />
        </div>
      </div>
      <div class="iframe-content">
        <iframe :src="useUserStore().iFrame" scroll="no"> </iframe>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { GenericController } from "@/stores/controller";
import VIcon from "@/components/VIcon.vue";
import { UserStoreFactory } from "@/stores/user";
import { fetchApiKey } from "@/stores/util.dom";
import { startRevBoosterTimer } from "@/stores/util.services";

const apikey = fetchApiKey();
const useUserStore = UserStoreFactory(apikey + "_user");

const closeModal = async () => {
  await GenericController.CurrentController().toggleIFrame(false);
  useUserStore().iFrame = undefined;
  startRevBoosterTimer();
};
</script>

<style>
.iframe-modal {
  position: fixed;
  display: flex;
  z-index: 20;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.iframe-content iframe {
  width: 100%;
  border: none;
  flex-grow: 1;
  height: 100%;
}
.iframe-content iframe::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}
.iframe-content {
  height: calc(100% - 50px);
}

.iframe-modal-content {
  max-width: 425px;
  width: 100%;
  margin: auto;
  background-color: white;
  height: 100%;
}
</style>
